export default {
    public: {
        doc: 'Help',
        yes: 'Yes',
        no: 'No',
        param: 'Parameter',
        noData: 'No data',
        dataType: 'Data type',
        describe: 'Description',
        require: 'Required',
        debug: 'Debug',
        debugResult: 'Debug result',
        pleaseSelect: 'Select',
        downLoad: 'Download',
        template: 'Template',
        downLoadTemplate: 'Download template',
        publicRequestParam: 'Public request parameters',
        workRequestParam: 'Service request parameters',
        requestExample: 'Sample request',
        example: 'Example',
        example1: 'Example',
        respondParam: 'Response parameters',
        respondCode: 'Response code',
        respondExample: 'Sample response',
        callBackRespondExample: 'Sample callback response',
        defaultValue: 'Default value',
        copySuccess: 'Copied'
    },
    home: {
        debugApi: 'Online API debug',
        searchWord: 'Search by keywords',
        seeRequireItem: 'Show required param only',
        fillDefaultValue: 'Auto fill',
        debugTip1: 'This parameter is obtained when debugging is initiated. For description, see Help.',
        debugTip2: 'This parameter is obtained when debugging is initiated. For description, see Help.',
        debugTip3: 'The debugging page supports writing at most 10 variables at a time.',
        uploadTip1: 'File changes detected, please upload the latest file.',
        pleaseSelectFile: 'Select file',
        clickChangeId: 'Click to switch between deviceId and serialNo',
        clickChangeName: 'Click to switch between deviceName and serialNo',
        clickChangeIot: 'Click to switch between iotName and regCode',
        clickChangeTemplateNameOrId: 'Click to switch between templateName and id',
        canSelectMore: 'You can enter multiple queryData and separate them by comma, eg., xx,xx,xx.',
        supportSlsx: 'The suffix of upload file must be xlsx.',
        errorFileFormat: 'The format of input field is incorrect.'
    },
    file: {
        apiIntroduce: 'API introduction',
        apiName: 'API name',
        apiProtocol: 'API protocol version',
        clickEnter: 'Click here',
        describe1: 'Appkey assigned to the application',
        describe2: 'Timestamp in the format yyyy-MM-dd HH:mm:ss, time zone GMT+8, e.g.: 2015-01-01 12:00:00. API server allows client requests valid for 3 minutes.',
        describe3: 'Signature results of API input parameters. For the signature algorithm'
    },
    debug: {
        noDebugResult: 'No debug result',
        debugTip1: 'After debugging is initiated, you can obtain debug results, real requested URL, response header and response body information here.',
        beginDebug: 'Debug',
        overView: 'Overview',
        debugSuccess: 'Debug success',
        debugFailed: 'Debug failed',
        consumeTime: 'Elapsed time',
        statusCode: 'Status code',
        requestType: 'Request type',
        realRequestUrl: 'URL   Real requested URL',
        requestData: 'Request',
        requestHeader: 'Header',
        requestData: 'Body',
        respondResult: 'Response',
        respondHeader: 'Header',
        respondBody: 'Body'
    }
}